document.addEventListener("DOMContentLoaded", function () {

  const content = document.querySelector(".article-template__content") 
               || document.querySelector(".rte");

  const tocContainer = document.getElementById("toc-container");

  if (!content || !tocContainer) return;

  const headings = content.querySelectorAll("h2, h3");

  if (!headings.length) return;

  let tocHTML = '<div class="toc-title">Contents</div><ul>';

  headings.forEach((heading, index) => {

    if (!heading.id) {
      heading.id = "toc-" + index + "-" + Math.random().toString(36).substr(2, 5);
    }

    const tag = heading.tagName.toLowerCase();
    const text = heading.textContent.trim();

    tocHTML += `
      <li class="toc-${tag}">
        <a href="#${heading.id}">${text}</a>
      </li>
    `;
  });

  tocHTML += "</ul>";
  tocContainer.innerHTML = tocHTML;
});